import { render, staticRenderFns } from "./CatalogGrid.vue?vue&type=template&id=ed094276&scoped=true&"
import script from "./CatalogGrid.vue?vue&type=script&lang=js&"
export * from "./CatalogGrid.vue?vue&type=script&lang=js&"
import style0 from "./CatalogGrid.vue?vue&type=style&index=0&id=ed094276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed094276",
  null
  
)

export default component.exports